module.exports = __webpack_public_path__ + "img/npm-logo-red.53c87272.svg";